// covered-by: frontends/carrie/src/components/__tests__/Markdown.test.tsx

interface HastNode {
  type: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
}

interface Options {
  properties: readonly string[];
}

const URL_SCHEME = /^[a-z][a-z\d+.-]*:/i;

function lowercaseSchemes(node: HastNode, keys: readonly string[]): void {
  if (node.type === "element" && node.properties) {
    for (const key of keys) {
      const value = node.properties[key];
      if (typeof value === "string") {
        node.properties[key] = value.replace(URL_SCHEME, (scheme) =>
          scheme.toLowerCase(),
        );
      }
    }
  }
  for (const child of node.children ?? []) lowercaseSchemes(child, keys);
}

/**
 * Lowercases the scheme of each URL property in `properties` and leaves the
 * rest of the URL as written, since paths are case-sensitive. URL schemes are
 * case-insensitive (RFC 3986 section 3.1) but rehype-sanitize's protocol
 * allowlist is not, so `HTTPS://` would otherwise fail an `https` allowlist.
 */
function plugin(options: Options) {
  return (tree: HastNode) => lowercaseSchemes(tree, options.properties);
}

export default plugin;
